import { useEffect } from "react"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import axios from "axios"

export interface Condition {
    fieldEId: string
    name: string
    isFieldMultiSelect: boolean
    fieldTypes: Array<{
        EId: string
        value: string
    }>
    values: Array<{
        EId: string
        value: string
    }>
}

type AutomationDataType = 'LONG'
type AutomationFilterType = 'REQUISITION'

interface Action {
    automationActionId: number
    actionType: string
    localeKey: string
    automationActionFields: Array<{
        actionField: string
        automationActionFieldId: number
        automationActionId: number
        dataType: AutomationDataType
        localeKey: string
    }>
}
export interface FilterField {
    automationFilterFieldId: number
    dataType: AutomationDataType
    filterField: string
    filterType: AutomationFilterType
    localeKey: string
    required: boolean
    requiredOnTriggerType: string
    statementOperatorRequired: boolean
    unsupportedOperatorValues: Array<string>
}
interface Trigger {
    automationTriggerId: number
    localeKey: string
    triggerType: string
}
interface AutomationFormDataResponse {
    ACTIONS: Array<Action>
    FILTER_FIELDS: Array<FilterField>
    TRIGGERS: Array<Trigger>
}

export type OnAutomationFormDataSuccess = (data: any) => void

async function fetchAutomationFormData() {

    const { data } = await axios.get<AutomationFormDataResponse>(`/admin/action/automation/admin/metadata`)

    return data
}

export const DEFAULT_AUTOMATION_FORM_DATA = {
    TRIGGERS: [],
    FILTER_FIELDS: [],
    ACTIONS: []
} as AutomationFormDataResponse

const AUTOMATION_FORM_DATA_QUERY = 'automations/form/metadata'

interface UseAutomationFormDataQueryProps {
    onSuccess: OnAutomationFormDataSuccess
}

export default function useAutomationFormDataQuery({
    onSuccess,
}: UseAutomationFormDataQueryProps) {
    return useQuery<AutomationFormDataResponse>({
        queryKey: [AUTOMATION_FORM_DATA_QUERY],
        onSuccess,
        queryFn: fetchAutomationFormData,
    })
}

export function useAutomationFormDataPrefetch() {
    const queryClient = useQueryClient()
    const prefetchFormData = async () => {
        try {
            queryClient.prefetchQuery({
                queryKey: [AUTOMATION_FORM_DATA_QUERY],
                queryFn: fetchAutomationFormData,
            })
        } catch(e) {
            console.log(e)
        }
    }

    useEffect(() => {
        prefetchFormData()
    }, [])
}
